import { connect } from "react-redux";

import CitiesVerticalChart from "../../components/visualizations/cities_vertical_chart";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.verticalChart)) { return {}; }

  const dataAndOptions = ld.verticalChart;
  const title = `Cities by combined ${state.main.filters.year.selectedValue.value} tariff`;

  return { dataAndOptions, title };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiesVerticalChart);
